import { useAlertsStore } from '@/store/pinia/alerts'
import { AppError, types as errTypes } from '@/utils/config/errors'
import { appMode } from '@/utils/config/mode'
import { throwBetterError } from '@/utils/helpers'
import i18n from '@/utils/plugins/i18n'

export default function errorHandler (err) {
  if (appMode.isStagingOrDev || appMode.isEEnv) {
    throwBetterError(err, errorHandler, { calleeName: 'router.onErrorHandler' })
  }

  const alertsStore = useAlertsStore()

  alertsStore.SHOW_ALERT({
    type: 'error',
    content: [AppError.fromError(
      err,
      'router.onErrorHandler: Captured error',
      i18n.global.t('errors.system'),
      errTypes.SYS,
    )],
  })
}
